export default __webpack_public_path__ + "static/media/ChatSupport.4217785f.svg";